import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";

export const TermsOfService = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-[#e1dcdc75] relative">
      {/* Navigation bar */}
      <div className="fixed w-full px-4 top-[46px] z-10">
        <div className="max-w-[1257px] mx-auto h-[77px] relative rounded-[28px]">
          <div className="absolute w-full h-full top-0 left-0 bg-white rounded-[28px] shadow-[0px_4px_4px_#00000040] blur-[3.05px] opacity-[0.53]" />
          <div className="relative h-full flex items-center justify-between px-6">
            <div className="flex items-center gap-4 cursor-pointer" onClick={() => navigate('/join')}>
              <img className="w-[27px] h-[27px] object-cover" alt="Beetle" src="/beetle.png" />
              <span className="font-['Space_Grotesk'] font-bold text-black text-[32px]">RAWPA</span>
            </div>
            <Button 
              className="w-[166px] h-[49px] bg-[#daed6e] rounded-[20px] border border-solid border-[#e7e7e7] hover:bg-[#c5d85c]"
              onClick={() => navigate('/join')}
            >
              <span className="font-['Space_Grotesk'] font-bold text-black text-[32px]">Back</span>
            </Button>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="container mx-auto px-4 pt-[160px] pb-16">
        <div className="max-w-4xl mx-auto bg-white rounded-[20px] p-8 shadow-lg">
          <div className="mb-8">
            <h1 className="font-['Space_Grotesk'] font-bold text-3xl text-black mb-4">
              Terms of Service
            </h1>
            <p className="font-['Space_Grotesk'] text-sm text-black opacity-80">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>

          <div className="space-y-6 font-['Space_Grotesk'] text-black">
            <section>
              <h2 className="font-bold text-xl mb-3">1. Acceptance of Terms</h2>
              <p className="text-base leading-relaxed">
                By accessing and using RAWPA (Rodney the Advanced Web Penetration Assistant), you accept and agree to be bound by the terms and provision of this agreement.
              </p>
            </section>

            <section>
              <h2 className="font-bold text-xl mb-3">2. Use License</h2>
              <p className="text-base leading-relaxed mb-3">
                Permission is granted to temporarily use RAWPA for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc list-inside space-y-2 text-base leading-relaxed">
                <li>modify or copy the materials</li>
                <li>use the materials for any commercial purpose or for any public display</li>
                <li>attempt to reverse engineer any software contained on RAWPA</li>
                <li>remove any copyright or other proprietary notations from the materials</li>
              </ul>
            </section>

            <section>
              <h2 className="font-bold text-xl mb-3">3. Disclaimer</h2>
              <p className="text-base leading-relaxed">
                The materials on RAWPA are provided on an 'as is' basis. RAWPA makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </section>

            <section>
              <h2 className="font-bold text-xl mb-3">4. Limitations</h2>
              <p className="text-base leading-relaxed">
                In no event shall RAWPA or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on RAWPA, even if RAWPA or a RAWPA authorized representative has been notified orally or in writing of the possibility of such damage.
              </p>
            </section>

            <section>
              <h2 className="font-bold text-xl mb-3">5. Ethical Use</h2>
              <p className="text-base leading-relaxed mb-3">
                RAWPA is designed for educational and authorized security testing purposes only. Users must:
              </p>
              <ul className="list-disc list-inside space-y-2 text-base leading-relaxed">
                <li>Only use the platform for authorized penetration testing activities</li>
                <li>Comply with all applicable laws and regulations</li>
                <li>Obtain proper authorization before testing any systems</li>
                <li>Not use the platform for malicious or unauthorized activities</li>
              </ul>
            </section>

            <section>
              <h2 className="font-bold text-xl mb-3">6. Accuracy of Materials</h2>
              <p className="text-base leading-relaxed">
                The materials appearing on RAWPA could include technical, typographical, or photographic errors. RAWPA does not warrant that any of the materials on its website are accurate, complete, or current. RAWPA may make changes to the materials contained on its website at any time without notice.
              </p>
            </section>

            <section>
              <h2 className="font-bold text-xl mb-3">7. Links</h2>
              <p className="text-base leading-relaxed">
                RAWPA has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by RAWPA of the site. Use of any such linked website is at the user's own risk.
              </p>
            </section>

            <section>
              <h2 className="font-bold text-xl mb-3">8. Modifications</h2>
              <p className="text-base leading-relaxed">
                RAWPA may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these Terms of Service.
              </p>
            </section>

            <section>
              <h2 className="font-bold text-xl mb-3">9. Governing Law</h2>
              <p className="text-base leading-relaxed">
                These terms and conditions are governed by and construed in accordance with the laws and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
              </p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Button 
              className="bg-[#daed6e] rounded-[20px] hover:bg-[#c5d85c] transition-colors"
              onClick={() => navigate('/join')}
            >
              <span className="font-['Space_Grotesk'] font-medium text-black text-base">Back to Join</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}; 